import React from "react";

const Categories: React.FC = () => {
  return (
    <div className="container">
      <div className="categories p60">
        <div className="cat-cards robotics">
          <h3>Robotics</h3>
          <p>
            A fun way for kids to learn STEM concepts by letting them make their
            own robots
          </p>
          <div className="bg-icon rob"></div>
        </div>
        <div className="cat-cards math">
          <h3>Mathematics</h3>
          <p>
            Lots of interactive Maths challenges for kids of different ages and
            abilities
          </p>
          <div className="bg-icon mat"></div>
        </div>
        <div className="cat-cards engineering">
          <h3>Engineering</h3>
          <p>
            Kids will learn how and why things work the way they do with
            practical concepts
          </p>
          <div className="bg-icon eng"></div>
        </div>
        <div className="cat-cards physics">
          <h3>Physics</h3>
          <p>
            Taking abstract concepts and presenting them in fun ways that make
            them easy to understand
          </p>
          <div className="bg-icon phy"></div>
        </div>
      </div>
    </div>
  );
};

export default Categories;
